export const QUERY = `
query Storage($productKey: String!) {
  attachmentStorage(productKey: $productKey) {
    used
    allowed
    isUnlimited
  }
}`;
